import { ProcessorService } from '@df/ng/processor.service';
import { NgZone } from '@angular/core';

export function copyToClipboard(copy: string) {
    const ngZone: NgZone = ProcessorService.injector.get(NgZone);
    ngZone.runOutsideAngular(() => {
        const el = document.createElement('input') as HTMLInputElement;
        document.body.appendChild(el);
        el.value = copy;
        el.select();
        el.setSelectionRange(0, 999999); /*For mobile devices*/
        document.execCommand('copy');
        document.body.removeChild(el);
    });
}
